import { AssignedLabel } from "./label.types";

export enum TemplateContentType {
  PLAIN_TEXT = "plain_text",
  HTML = "html",
}

export type TemplateType = {
  _id: string;
  title: string;
  subject: string;
  content: string;
  contentType: TemplateContentType;
  tags: string[];
  reportId?: {
    _id: string;
    report: TemplateCheckResponse;
  };
  createdAt: string;
  updatedAt: string;
  createdBy?: string;
  updatedBy?: string;
  organization?: string;
  labelIds?: AssignedLabel[];
};

export type TemplateCheck = {
  spamScore: number;
  wordCount: number;
  readabilityTime: number;
  subjectLength: number;
  numberOfLinks: number;
  personalization: number;
};

export type Weights = {
  spamWords: number;
  altAttributes: number;
  brokenLinks: number;
  dangerousHtml: number;
  shortenedUrls: number;
  readTime: number;
};

export type TemplateCheckResponse = {
  score: number;
  weights: Weights;
  countData: {
    subjectLength: number;
    wordCount: {
      upperCase: {
        count: number;
        words: string[];
      };
      wordCount: number;
    };
    spamWords: {
      count: number;
      details: {
        [category: string]: {
          words: string[];
          count: number;
        };
      };
    };
    image: {
      imageCount: number;
      invalidCount: number;
      emptyAltCount: number;
      details: {
        src: string;
        alt: string | null;
        isValid: boolean;
        issues: Array<
          "missing_alt" | "empty_alt" | "missing_src" | "invalid_src"
        >;
      }[];
    };
    links: {
      count: number;
      details: {
        href: string;
        text: string;
        isValid: boolean;
        reason?: "missing_protocol" | "invalid_protocol";
      }[];
    };
    dangerousHtml: {
      count: number;
      details: Array<{
        type: string;
        src: string;
      }>;
    };
    shortenedUrls: {
      count: number;
      details: Array<{
        url: string;
        service: string;
      }>;
    };
    questions: string[];
    readTime: {
      seconds: number;
    };
    unsubscribeLink: {
      have: boolean;
      link: string;
    };
    personalisation: {
      validTokensCount: number;
      invalidCount: number;
      allTokensCount: number;
      details: {
        token: string;
        isValid: boolean;
      }[];
    };
  };
};

export type TemplateReport = {
  _id: string;
  companyId: string;
  templateId: string;
  report: TemplateCheckResponse;
  createdAt: string;
  updatedAt: string;
};

export type MetricThreshold = {
  min: number;
  max: number;
  warningThreshold?: number; // Value above which we show yellow
};

export type MetricConfig = {
  label: string;
  description: string;
  thresholds: MetricThreshold;
  unit?: string;
  showCondition?: (contentType: string) => boolean;
};

export type TemplateMetrics = {
  spamScore: number;
  wordCount: number;
  readabilityTime: number;
  subjectLength: number;
  numberOfLinks: number;
  personalisation: number;
  questions: number;
  brokenLinks: number;
  dangerousHtml: number;
  shortenedUrls: number;
  imageCount: number;
  emptyAltCount: number;
  spamWords: number;
  upperCaseWords: number;
  unsubscribeLink: number;
};
